module.exports = __webpack_public_path__ + "static/media/01A.72be089a.png";